import { ScreenType } from '../config/ScreenConfig';

import { FilterSelection } from './SearchBar/FilterResolvers';

export const PEOPLE_FIELD_SCREEN_TYPES: ScreenType[] = ['BROWSE_DEPARTMENTS', 'BROWSE_JOB_TITLES', 'BROWSE_LOCATIONS'];

// Exported for use in teams app navigation matching (these screen types redirect to separate views)
export const TEAM_SEARCH_SCREEN_TYPES: ScreenType[] = ['SEARCH_TEAMS', 'YOUR_TEAMS'];

export const SEARCH_BAR_PREVIEW_TQL_SCREEN_TYPES: ScreenType[] = ['BROWSE_ALL'];

// Restrict based on the screen, otherwise based on current filters
export const filterRestrictionForScreen = (
	currentFilterSelection: FilterSelection,
	currentScreen: ScreenType,
): FilterSelection => {
	switch (currentScreen) {
		case 'BROWSE_KUDOS':
			return 'kudos';
		default:
			return currentFilterSelection;
	}
};
